export default __webpack_public_path__ + "static/media/batcheshero.527b4eb9.png";